import { render, staticRenderFns } from "./settings-account-password.vue?vue&type=template&id=43b56c96&scoped=true&"
import script from "./settings-account-password.vue?vue&type=script&lang=js&"
export * from "./settings-account-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b56c96",
  null
  
)

export default component.exports